module.exports = __webpack_public_path__ + "static/media/start-expl.e380fff0.svg";